@if (toastVisible()) {
  <div [class]="containerClasses()">
    @if (snackbar()) {
      <div
        [class]="cardWidthClass()"
        class="p-4 bg-secondary_subtle rounded-xl shadow-toast border border-primary flex items-center gap-4 cursor-pointer"
        role="button"
        tabindex="0"
        aria-label="Dismiss"
        data-testid="toast-dismiss"
        (click)="hideToast()"
        (keydown.enter)="hideToast()">
        <p class="min-w-0 flex-1 truncate text-secondary text-base font-normal">
          {{ toastTitle() }}
        </p>
        @if (actionLabel()) {
          <button
            class="shrink-0 text-base font-semibold text-brand-primary"
            data-testid="toast-action"
            (click)="$event.stopPropagation(); onActionClick()">
            {{ actionLabel() }}
          </button>
        }
      </div>
    } @else {
      <div
        [class]="cardWidthClass()"
        class="p-4 bg-secondary_subtle rounded-xl shadow-toast border border-primary">
        <div class="flex gap-4" [class.items-center]="compact()">
          <div class="space-y-1" [class.flex-1]="!compact()">
            <p [class]="titleWeightClass()" class="text-secondary text-base">
              {{ toastTitle() }}
            </p>
            @if (toastMessage()) {
              <p class="text-tertiary text-base font-normal">
                {{ toastMessage() }}
              </p>
            }
            @if (actionLabel()) {
              <button
                class="mt-1 text-base font-semibold text-brand-primary"
                data-testid="toast-action"
                (click)="onActionClick()">
                {{ actionLabel() }}
              </button>
            }
          </div>

          @if (compact()) {
            <button
              class="w-6 h-6 shrink-0 rounded-lg flex items-center justify-center text-primary"
              (click)="hideToast()"
              aria-label="Close">
              <svg-icon
                src="assets/svg/x-close.svg"
                class="w-5 h-5 flex items-center justify-center"
                svgClass="w-5 h-5" />
            </button>
          } @else {
            <button
              class="w-10 h-10 p-2 absolute top-2 right-2 rounded-lg flex items-center justify-center text-primary"
              (click)="hideToast()"
              aria-label="Close">
              <svg-icon
                src="assets/svg/x-close.svg"
                class="w-5 h-5 flex items-center justify-center"
                svgClass="w-5 h-5" />
            </button>
          }
        </div>
      </div>
    }
  </div>
}
